import { useMemo } from 'react';
import { RadioGroup } from '@ets/design-system';

import styles from './SynonymGroup.module.scss';

type SynonymGroupProps = {
  group: Synonym;
  query: string;
  onChange: (id: string, value: string) => void;
  selectedValue: {
    id: string;
    value: string;
  };
  index: number;
};

const SynonymGroup = ({ group, query, onChange, selectedValue, index }: SynonymGroupProps) => {
  const synonyms = useMemo(() => {
    return group.list.synonyms.split('|').map((synonym, i) => {
      const split = synonym.split('(');
      const value = split[0];
      const description = split[1] ? `(${split[1]}` : '';
      const id = index + value + i;
      return {
        id,
        label: `${value} ${description.length > 0 ? description : ''}`,
        value,
      };
    });
  }, []);

  return (
    <div key={group.list.synonyms} className={styles.group}>
      <p>
        {query} {group.list.category}:
      </p>
      <div className={styles.items}>
        <RadioGroup
          items={synonyms}
          testId="synonym"
          size="xs"
          direction="vertical"
          value={selectedValue.value}
          onChange={(e) => {
            const synonymId = synonyms.filter((value) => value.value === e.target.value);
            onChange(synonymId[0]?.id, e.target.value);
          }}
        />
      </div>
    </div>
  );
};

export default SynonymGroup;
